import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { PartnerConfig } from './config/model';
import { PARTNER_CONFIG } from './config/token';

export function providePartner(config: PartnerConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: PARTNER_CONFIG,
      useValue: config,
    },
  ]);
}
